export const FOCUSED_PIN_Z_INDEX = 500;
export const POPUP_PREVIEW_DURATION = 1200;
